<template>
  <modal
    width="320px"
    speed="fast"
    noOutClose
    noClose
    maskNoClick
    :show="show"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    @update:show="close"
    class="camera-error-tip"
  >
    <p slot="header">提示</p>
    <p slot="content" class="text">
      <span>摄像头或麦克风</span>异常
    </p>
    <div slot="footer">
      <a href="https://shimo.im/docs/gtrrTvKvvKGxjTDy/"
         class="blue-btn"
         target="_blank">解决方案</a>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  components: {
    Modal
  },
  data() {
    return {
      show: true
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/.modal-head {
    padding: 16px 20px;
    border-bottom: 1px solid #F1F1F1;
  }
  .camera-error-tip {
    .text {
      font-size: 16px;
      color: #333;
      text-align: center;
      span {
        font-weight: 500;
      }
    }
  }
  .blue-btn {
    display: inline-block;
    @include theme-fill-btn(96px, 36px, 14px, 4px);
    margin-bottom: 10px;
  }
</style>
